import { createAuthClient } from 'better-auth/react';

export const authClient = createAuthClient({
  // No baseURL — uses current page origin, which Vite proxies to the backend.
  // This ensures auth works on any IP/hostname (localhost, 192.168.x.x, etc.)
  baseURL: window.location.origin,
  basePath: '/auth',
});
